import apiClient from 'services/apiClient';

export const DEFAULT_AUTH_REDIRECT = '/customer-portal/operating-analysis';

export const getPostLoginRedirectPath = (fromLocation, defaultPath = DEFAULT_AUTH_REDIRECT) => {
    const pathname = fromLocation?.pathname;

    if (!pathname || pathname === '/' || pathname === '/customer-portal' || pathname === '/login') {
        return defaultPath;
    }

    const search = fromLocation.search || '';
    const hash = fromLocation.hash || '';
    return `${pathname}${search}${hash}`;
};

export const handleSubmission = (target, obj, setObj) => {
    let newObj = { ...obj };
    newObj[target.name] = target.value;
    setObj(newObj);
}

export const submission = async (e, obj, url, setErr, navigateTo, router, setLoading, setAuth, createCookie, requestConfig, successPath = DEFAULT_AUTH_REDIRECT) => {
    e.preventDefault();
    setLoading(true);
    
    try {
        const res = await apiClient.post(url, obj, requestConfig);
        
        if (res.data.access) {
            createCookie && createCookie(res.data.access, obj.username);
            setAuth && setAuth(true);
            
            // Use try-catch for navigation to handle any potential errors
            try {
                navigateTo && navigateTo(successPath || DEFAULT_AUTH_REDIRECT);
            } catch {
                setErr({ general: 'Navigation failed after sign in.' });
            }
        } else {
            setAuth && setAuth(false);
        }
    } catch (error) {
        if (url.includes('auth/token/') && !error.isNetworkError) {
            // Provide a generic error message for login failures
            setErr({
                'general': "We don't recognize this sign in combination"
            });
        } else {
            setErr(error.data || { 'general': error.message || 'An error occurred' });
        }
    } finally {
        setLoading(false);
    }
}
